export default __webpack_public_path__ + "static/media/install-and-init.67f983b1.gif";